import { apiUrl } from '../utils/constants';
import { DELETE, GET, POST, PUT } from './api.service.wrapper';



export const GetDailyQuote = async (keyword = '', page = '', perPage = '', is_paginate = 1, status = null) => {
    let params = {};

    if (page) {
        params['page'] = page;
    }

    if (perPage) {
        params['per_page'] = perPage;
    }


    if (keyword) {
        params['author'] = keyword;
    }

    if (status) {
        params['status'] = status;
    }
    params['paginate'] = is_paginate;

    const response = await GET(apiUrl.daily_quote, params);
    return response;
}

export const GetDailyQuoteById = async (id) => {
    let params = {};
    let response = '';
    response = await GET(apiUrl.daily_quote + '/' + id,params);
    return response;
}

export const CreateDailyQuote = async (data) => {
    const response = await POST(apiUrl.daily_quote, data);
    return response;
}

export const UpdateDailyQuote = async (id, data) => {
    const response = await PUT(apiUrl.daily_quote, id, data);
    return response;
}

export const DeleteDailyQuote = async (id) => {
    const response = await DELETE(apiUrl.daily_quote, id);
    return response;
}
